import React from 'react'
import { Setting } from '../components'

export default function SettingPage() {
    return <Setting />
}
